<template>
  <div class="tiptap-editor-container">
    <div v-if="editor" class="tiptap-toolbar">
      <button type="button" :class="{ 'is-active': editor.isActive('bold') }" @click="editor.chain().focus().toggleBold().run()" title="Fet"><strong>B</strong></button>
      <button type="button" :class="{ 'is-active': editor.isActive('italic') }" @click="editor.chain().focus().toggleItalic().run()" title="Kursiv"><em>I</em></button>
      <button type="button" :class="{ 'is-active': editor.isActive('underline') }" @click="editor.chain().focus().toggleUnderline().run()" title="Understruken"><u>U</u></button>
      <button type="button" :class="{ 'is-active': editor.isActive('orderedList') }" @click="editor.chain().focus().toggleOrderedList().run()" title="Numrerad lista"><span class="glyphicon glyphicon-list-alt"></span></button>
      <button type="button" :class="{ 'is-active': editor.isActive('bulletList') }" @click="editor.chain().focus().toggleBulletList().run()" title="Punktlista"><span class="glyphicon glyphicon-list"></span></button>
    </div>
    <editor-content :editor="editor" />
  </div>
</template>

<script setup lang="ts">
import { watch, onBeforeUnmount } from 'vue';
import { useEditor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';

const props = defineProps<{ modelValue: string }>();
const emit = defineEmits<{ 'update:modelValue': [value: string] }>();

const editor = useEditor({
  content: props.modelValue,
  extensions: [StarterKit, Underline],
  onUpdate({ editor: e }) {
    emit('update:modelValue', e.getHTML());
  },
});

watch(() => props.modelValue, (val) => {
  if (editor.value && editor.value.getHTML() !== val) {
    editor.value.commands.setContent(val ?? '');
  }
});

onBeforeUnmount(() => {
  editor.value?.destroy();
});
</script>

<style scoped>
.tiptap-editor-container {
  .tiptap-toolbar {
    display: flex;
    gap: 0.25rem;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-bottom: none;
    background: #f8f8f8;
    border-radius: 0.25rem 0.25rem 0 0;

    button {
      margin: 0;
      padding: 0.25rem 0.625rem;
      background: none;
      border: 1px solid transparent;
      border-radius: 0.25rem;
      cursor: pointer;
      line-height: 1.4;

      &:hover {
        background: #e8e8e8;
        border-color: #ccc;
      }

      &.is-active {
        background: #dde;
        border-color: #aaa;
      }
    }
  }

  :deep(.ProseMirror) {
    background-color: #fff;
    font-size: 1.9rem;
    min-height: 20rem;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 0 0 0.25rem 0.25rem;
    outline: none;

    &:focus {
      border-color: #66afe9;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
    }

    p { margin-bottom: 0.5rem; }
    ul, ol { padding-left: 1.5rem; }
    li p { margin-bottom: 0; }
  }
}
</style>
